import Skeleton, { SkeletonProps } from 'react-loading-skeleton';
import { SkeletonGrey, SkeletonWhite } from 'utils/constants';

interface GenericSkeletonProps extends SkeletonProps {
  overrideBaseColor?: string;
  overrideHighlightColor?: string;
  inverseColors?: boolean;
}

const GenericSkeleton = ({
  overrideBaseColor,
  overrideHighlightColor,
  inverseColors,
  ...props
}: GenericSkeletonProps) => {
  return (
    <Skeleton
      baseColor={
        overrideBaseColor
          ? overrideBaseColor
          : inverseColors
            ? SkeletonWhite
            : SkeletonGrey
      }
      highlightColor={
        overrideHighlightColor
          ? overrideHighlightColor
          : inverseColors
            ? SkeletonGrey
            : SkeletonWhite
      }
      {...props}
    />
  );
};

export default GenericSkeleton;
